import { useCallback, useMemo } from 'react'

import { PartnerFormMenuItems } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { useGetFormDataField } from 'cng-common/features/form'

import {
  PartnerEditorFormKeys,
  PartnerEditorFormSettings,
  READ_ONLY_WORKFLOW_STATUS,
} from '../configs'

export const useEditMenuItems = (partner: IPartner) => {
  const [currentMenuItem] = useGetFormDataField<PartnerFormMenuItems>(
    PartnerEditorFormKeys.Setting,
    PartnerEditorFormSettings.CurrentMenuItem
  )
  const [editableMenuItems, updateEditableMenuItems] = useGetFormDataField<PartnerFormMenuItems[]>(
    PartnerEditorFormKeys.Setting,
    PartnerEditorFormSettings.EditableMenuItems
  )

  const isWorkflowStatusReadOnly = useMemo(() => {
    if (currentMenuItem === PartnerFormMenuItems.Basic) {
      return READ_ONLY_WORKFLOW_STATUS.includes(partner.workflowStatus)
    }
    if (currentMenuItem === PartnerFormMenuItems.Legal) {
      return READ_ONLY_WORKFLOW_STATUS.includes(partner.legalWorkflowStatus)
    }

    return false
  }, [currentMenuItem, partner.legalWorkflowStatus, partner.workflowStatus])

  const isCurrentMenuItemEditable = useMemo(
    () => editableMenuItems.includes(currentMenuItem) && !isWorkflowStatusReadOnly,
    [currentMenuItem, editableMenuItems, isWorkflowStatusReadOnly]
  )

  const setIsCurrentMenuItemEditable = useCallback(
    (isEditable: boolean) => {
      if (isEditable && !isCurrentMenuItemEditable) {
        updateEditableMenuItems([...editableMenuItems, currentMenuItem])
      }

      if (!isEditable && isCurrentMenuItemEditable) {
        updateEditableMenuItems(editableMenuItems.filter((item) => item !== currentMenuItem))
      }
    },
    [updateEditableMenuItems, currentMenuItem, editableMenuItems, isCurrentMenuItemEditable]
  )

  return {
    isWorkflowStatusReadOnly,
    isCurrentMenuItemEditable,
    setIsCurrentMenuItemEditable,
    currentMenuItem,
  }
}
